import HttpClient from "@/api/utils/HttpClient"

export const apiGatewayClient = HttpClient({
  baseURL: import.meta.env.SO_API_GATEWAY_URL,
})
